(function () {
  var selector = '[data-hypest-grip-id]';
  var noticeText = 'Er lagen minder paar van deze maat. We passen je winkelwagen aan.';
  var busy = false;
  var failed = false;
  var queued = false;

  function gate(disabled) {
    if (disabled) document.documentElement.dataset.hypestGripChecking = '1';
    else delete document.documentElement.dataset.hypestGripChecking;
    document.querySelectorAll('button[name="checkout"]').forEach(function (element) {
      element.disabled = disabled;
    });
  }

  function message(text) {
    var container = document.querySelector('#CartDrawer-CartErrors, #cart-errors');
    if (!container) return;
    container.setAttribute('role', 'alert');
    container.textContent = text;
  }

  function overstocked(cart, limitsById) {
    var totals = {};
    cart.items.forEach(function (item) {
      if (Object.prototype.hasOwnProperty.call(limitsById, String(item.variant_id))) {
        totals[item.variant_id] = (totals[item.variant_id] || 0) + item.quantity;
      }
    });
    return Object.keys(totals).some(function (id) { return totals[id] > limitsById[id]; });
  }

  async function check() {
    if (busy || !document.querySelector(selector)) {
      if (!busy) gate(failed);
      return;
    }
    busy = true;
    gate(true);
    try {
      var cart = await fetch(window.routes.cart_url + '.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (response) {
        if (!response.ok) throw new Error('Winkelwagen tijdelijk niet bereikbaar');
        return response.json();
      });
      var response = await fetch(window.routes.cart_url + '?section_id=main-cart-items', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Voorraad tijdelijk niet bereikbaar');
      var fresh = new DOMParser().parseFromString(await response.text(), 'text/html');
      var currentLimits = {};
      fresh.querySelectorAll(selector).forEach(function (row) {
        var stock = Number(row.dataset.hypestGripStock);
        if (Number.isFinite(stock)) currentLimits[row.dataset.hypestGripId] = Math.max(0, stock);
      });
      if (!Object.keys(currentLimits).length) throw new Error('Voorraad tijdelijk niet bereikbaar');
      if (!overstocked(cart, currentLimits)) {
        failed = false;
        gate(false);
        return;
      }
      message(noticeText);
      // Properties can split one variant into several lines. Keep each line key
      // and private bundle label while trimming the later lines first.
      var remaining = {};
      for (var index = 0; index < cart.items.length; index++) {
        var item = cart.items[index];
        var id = String(item.variant_id);
        if (!Object.prototype.hasOwnProperty.call(currentLimits, id)) continue;
        if (!Object.prototype.hasOwnProperty.call(remaining, id)) remaining[id] = currentLimits[id];
        var target = Math.min(item.quantity, remaining[id]);
        remaining[id] -= target;
        if (target === item.quantity) continue;
        var result = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: target })
        });
        if (!result.ok) throw new Error('Aantal kon niet worden aangepast');
      }
      var verified = await fetch(window.routes.cart_url + '.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (response) { return response.json(); });
      if (overstocked(verified, currentLimits)) throw new Error('Voorraad is veranderd');
      window.location.reload();
    } catch (error) {
      failed = true;
      message('Controle van deze maat lukte niet. Probeer het opnieuw.');
      // Do not allow checkout after an unverified correction.
    } finally {
      busy = false;
      if (failed) gate(true);
    }
  }

  function schedule() {
    if (queued) return;
    gate(true);
    queued = true;
    setTimeout(function () {
      queued = false;
      check();
    }, 0);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[name="checkout"], .additional-checkout-buttons')) {
      if (busy || failed) event.preventDefault();
      schedule();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    if (busy || failed) {
      event.preventDefault();
      schedule();
    }
  }, true);
  document.addEventListener('cart-drawer:refresh', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  new MutationObserver(function (changes) {
    if (changes.some(function (change) { return change.addedNodes.length && change.target.closest && change.target.closest('cart-items, cart-drawer-items'); })) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
